export default function TeleHealthRecords() {
    return (
        <div>Health records</div>
    )
}